// extracted by mini-css-extract-plugin
export var modal = "_fp-0";